module.exports = __webpack_public_path__ + "img/pic_5.9dd23c5b.png";